import styled from "@emotion/styled";

export const Main = styled.main`
text-align: center;
margin: 20px auto;
padding: 20px;
background-color: #fff;
width: 1000px;
box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
`;

export const MainTitle = styled.h1`
display: flex;
justify-content: center;
align-items: center;
margin: 0 auto;
padding-top: 15px;
padding-bottom: 15px;
color: #22c1c3;
`;

export const HomeContainer = styled.div`
`;
export const HomeImg = styled.img``;

export const HomeText = styled.p`
font-weight: 600;
margin-bottom: 20px;
`;
export const ContactsWrap = styled.div`
`;
export const ContactsSection = styled.div`
display: flex;
justify-content: space-between;
`;
